<template>
  <div class="hr-chips">
    <div class="hr-chips__label">
      <slot></slot>
      <co-icon
        v-if="$slots.helper"
        class="hr-chips__helper-icon"
        name="info-circle"
        @click="toggleHelper"
      ></co-icon>
      <p v-if="state.theHelper" class="hr-chips__helper">
        <slot name="helper"></slot>
      </p>
    </div>
    <co-radio
      v-for="(item, index) in items"
      :key="index"
      v-model="state.theValue"
      type="pill"
      size="large"
      :label="item.id"
      :disabled="disabled"
      :data-test-id="`hr-radio-pill-${item.id}`"
      :class="{
        'fs-mask': masked,
      }"
      @change="input(item.id)"
    >
      {{ item.description }}
    </co-radio>
    <div
      v-if="optionHints && optionHints[state.theValue]"
      class="hr-chips__option-hint"
    >
      <p v-html="optionHints[state.theValue]"></p>
    </div>
  </div>
  <div v-if="errorMessage" class="hr-chips__error">
    {{ errorMessage }}
  </div>
</template>

<script>
import { CoIcon, CoRadio } from '@deputy/copilot2';
import { reactive, watch } from 'vue';
export default {
  name: 'hr-chips',
  components: { CoIcon, CoRadio },
  props: {
    value: {
      type: String,
      default: null,
      description: 'component value',
    },
    items: {
      type: Array,
      default: () => [],
      description: 'array of options with {id, description}',
    },
    optionHints: {
      type: Object,
      default: () => ({}),
    },
    errorMessage: {
      type: String,
      default: null,
    },
    masked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:value'],
  setup(props, { emit, slots }) {
    const state = reactive({
      theValue: null,
      theHelper: slots.helper,
    });

    watch(
      () => slots.helper,
      (newVal) => {
        state.theHelper = newVal;
      }
    );

    watch(
      () => props.value,
      (newVal) => {
        setValue(newVal);
      }
    );

    if (props.value) {
      setValue(props.value);
    }

    function setValue(value) {
      state.theValue = value && value.id ? value.id : value;
    }

    function input(value) {
      state.theValue = value;
      emit('update:value', state.theValue);
    }

    function toggleHelper() {
      state.theHelper = !state.theHelper;
    }

    return {
      state,
      input,
      toggleHelper,
    };
  },
};
</script>

<style scoped lang="scss">
.co-radio--pill {
  font-weight: normal;
}
:deep(.co-radio--pill__inner) {
  margin-bottom: 12px;
}
:deep(.co-radio--pill__label) {
  line-height: 25px;
}
.hr-chips__bubble {
  display: inline-block;
  min-height: 40px;
  min-width: 90px;
  border: 1px solid #ced6db;
  border-radius: 44px;
  background-color: var(--co-background-primary);
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.07), 0 -0.5px 0 0 rgba(0, 0, 0, 0.16);

  color: #093149;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  margin: 5px;
  padding: 7px 15px;
}

.hr-chips__bubble.selected {
  background-color: #093149;
  border-color: #093149;
  color: var(--co-background-primary);
}

.hr-chips__bubble-container {
  position: relative;
  overflow: auto;
  width: 100%;
  height: 80px;
  white-space: nowrap;
}

.hint {
  position: absolute;
  background: skyblue;
  height: 100%;
  width: 10px;
  top: 0;
  right: 0;
  z-index: 10;
}

.hr-chips__label {
  font-weight: 600;
  margin-bottom: 8px;
}

.hr-chips__label .DSIcon {
  margin-left: 5px;
  font-size: 14px;
  cursor: pointer;
}

.hr-chips__helper {
  color: var(--co-text-secondary);
  font-size: 14px;
  margin: 0;
  margin-top: 10px;
  line-height: 20px;
  margin-bottom: 13px;
}

.hr-chips__option-hint {
  flex-basis: 100%;
  margin-top: 8px;
  color: var(--co-text-secondary);
}

.hr-chips__error {
  color: var(--co-status-red);
}

@media only screen and (max-width: 768px) {
  .hr-chips,
  .hr-chips__helper,
  .hr-chips__error,
  .co-radio--pill :deep(.co-radio--pill__label) {
    font-size: 16px;
  }
}
</style>
